/**
 * Utility method used to ensure that switch statements are exhaustive
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function assertUnreachable(_x: never): never {
  throw new Error('Unreachable code error');
}
